import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReduxState } from "..";
import { getXeroTaxRates } from "../../docuclipper/api";

export interface XeroTaxRate {
  name: string;
  value: string;
  rate?: number;
  taxType?: string;
}

const initialState: {
  xeroTaxRates: XeroTaxRate[];
  loading: boolean;
  error: string | null;
} = {
  xeroTaxRates: [],
  loading: false,
  error: null,
};

const slice = createSlice({
  name: "XeroTaxRate",
  initialState,
  reducers: {
    load(state) {
      state.loading = true;
      state.error = null;
    },
    setData(state, action: PayloadAction<XeroTaxRate[]>) {
      state.loading = false;
      state.xeroTaxRates = action.payload;
    },
    setError(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { load, setError, setData } = slice.actions;

export const fetchXeroTaxRates = (integrationId: number) => async (dispatch, getState) => {
  const state: ReduxState = getState();
  if (state.XeroTaxRate.loading) {
    return;
  }
  dispatch(load());
  try {
    const taxRates = await getXeroTaxRates(integrationId);
    dispatch(
      setData(
        (taxRates || []).map((t: any) => ({
          // Xero API returns lowercase field names
          name: t.name || t.Name,
          value: t.taxType || t.TaxType,
          rate: t.effectiveRate || t.displayTaxRate || t.EffectiveRate || t.DisplayTaxRate,
          taxType: t.taxType || t.TaxType,
        }))
      )
    );
  } catch (err) {
    dispatch(setError((err as any).message || "Error getting Xero tax rates"));
  }
};

export default slice.reducer;

